module.exports = {"cancel-subscription-reminders":{"confirmation-page-text":"<p>Geachte klant,</p><p>U heeft aangegeven geen herinnering meer te willen ontvangen.</p><p>Wij zullen u geen e-mail meer sturen wanneer uw abonnement afloopt.</p><p>Met vriendelijke groet,</p><p>Arriva Nederland</p>"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/subscriptions.json
// module id = igmz
// module chunks = 1